module.exports = __webpack_public_path__ + "img/Slide17.d21b198f.png";